import React from 'react';

import DeviceObject from '../DeviceObject';
import ReturnStatusIndicator from '../ReturnStatusIndicator';

const renderDevices = (
  devices,
  showStatus,
  returnInitiation,
  showDeviceSummary,
) => devices.map((device) => {
  const status = (device.deviceFound) ? 'In Progress' : 'Completed';

  return (
    <div className="card-group__item" key={device.id}>
      <div className={`card card--secondary ${(showStatus) ? 'card--action-right-at-768' : ''}`}>
        <div className="card__content">
          <DeviceObject
            device={device}
            showSummary={showDeviceSummary}
            returnInitiation={returnInitiation}
          />
        </div>
        {showStatus && (
          <div className="card__action">
            <ReturnStatusIndicator status={status} />
          </div>
        )}
      </div>
    </div>
  );
});

const ReturnDevices = (props) => {
  const {
    devices,
    showStatus,
    returnInitiation,
    showDeviceSummary = true,
  } = props;

  return (
    <>
      <div className="card-group__item">
        <div className="card">
          <div className="card__content">
            <h3 className="heading3">
              {'Devices You\'re Returning'}
            </h3>
          </div>
        </div>
      </div>

      {renderDevices(devices, showStatus, returnInitiation, showDeviceSummary)}
    </>
  );
};

export default ReturnDevices;
